import { List, ListItem, ListItemText, styled } from '@mui/material';

export const ListStyled = styled(List, {
  shouldForwardProp: (prop) => prop !== 'hasMarginBottom',
})(({ hasMarginBottom }) => ({
  padding: 0,
  marginBottom: hasMarginBottom && '16px',
}));

export const ListItemStyled = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'noTopRadius',
})(({ theme, noTopRadius }) => ({
  width: '344px',
  height: '32px',
  backgroundColor: theme.palette.colors.primaryBackground,
  justifyContent: 'space-between',
  padding: '0 8px',
  '&:first-of-type': {
    borderTopLeftRadius: !noTopRadius && '5px',
    borderTopRightRadius: !noTopRadius && '5px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
  },
  '&:not(:last-of-type)': {
    marginBottom: '1px',
  },
  [theme.breakpoints.up('md')]: {
    width: '603px',
    padding: '0 22px',
  },
}));

export const ListItemTextStyled = styled(ListItemText)(({ theme }) => ({
  flex: 'none',
  color: theme.palette.colors.mainFocused,
  '& .MuiListItemText-primary': {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
  },
}));
